export interface ChessboardLocationDto {
  id: string;
  chessboardId: string;
  locationId: string;
  location?: {
    id: string;
    name: string;
  };
}

export interface ChessboardDto {
  id: string;
  type: ChessboardType;
  status: ChessboardStatus;
  fen: string;
  version: number;
  gameNumber: number;
  moveCount: number;
  pendingAction: ChessboardPendingAction;
  pendingActionByUserId?: string;
  pendingActionColor?: ChessColor;
  pendingActionAt?: string;
  lastMoveByUserId?: string;
  lastMoveAtLocationId?: string;
  lastMoveAt?: string;
  result?: ChessboardResult;
  completedAt?: string;
  isVetted: boolean;
  plantedByUserId?: string;
  plantedByUser?: { id: string; username: string };
  participantUserIds: string[];
  /** When the requesting user may act here again. Absent means right now. */
  nextMoveAt?: string;
  chessboardLocations?: ChessboardLocationDto[];
  createdAt: string;
  updatedAt: string;
}

export interface ChessMoveDto {
  id: string;
  chessboardId: string;
  userId: string;
  locationId: string;
  moveNumber: number;
  color: ChessColor;
  move: string;
  fen: string;
  gpsAccuracy?: number;
  createdAt: string;
}

export interface ChessboardActionLogDto {
  id: string;
  chessboardId: string;
  userId: string;
  actionType: ChessboardActionType;
  color: ChessColor;
  createdAt: string;
}

export interface VettedLocationDto {
  id: string;
  name: string;
}

export interface MyBoardEntry {
  board: ChessboardDto;
  locationId: string;
  locationName: string;
  locationCoverBlobHash?: string;
  locationCoordinates?: { lat: number; lng: number };
}

export interface MyBoardsDto {
  active: MyBoardEntry[];
  completed: MyBoardEntry[];
}

export interface CreateChessboardPayload {
  locationId?: string;
  locationIds?: string[];
  type?: ChessboardType;
}

export interface MakeMovePayload {
  from: string;
  to: string;
  promotion?: string;
  expectedVersion: number;
  lat: number;
  lng: number;
  gpsAccuracy?: number;
  locationId: string;
}

export interface ChessboardActionPayload {
  action: ChessboardActionType;
  lat: number;
  lng: number;
  locationId: string;
}

export enum ChessboardType {
  LOCAL = 'local',
  WORLD = 'world',
}

export enum ChessboardStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
  ABANDONED = 'abandoned',
}

export enum ChessboardPendingAction {
  NONE = 'none',
  RESIGNATION_OFFERED = 'resignation_offered',
  DRAW_OFFERED = 'draw_offered',
}

export enum ChessboardResult {
  WHITE_WIN = 'white_win',
  BLACK_WIN = 'black_win',
  DRAW = 'draw',
  STALEMATE = 'stalemate',
}

export enum ChessColor {
  WHITE = 'white',
  BLACK = 'black',
}

export enum ChessboardActionType {
  RESIGN = 'resign',
  OFFER_DRAW = 'offer_draw',
  ACCEPT_DRAW = 'accept_draw',
  ACCEPT_RESIGNATION = 'accept_resignation',
  CANCEL_ACTION = 'cancel_action',
  DECLINE_ACTION = 'decline_action',
}
